import { render, staticRenderFns } from "./ConsumableCard.vue?vue&type=template&id=ec5324ac&scoped=true&"
import script from "./ConsumableCard.vue?vue&type=script&lang=js&"
export * from "./ConsumableCard.vue?vue&type=script&lang=js&"
import style0 from "./ConsumableCard.vue?vue&type=style&index=0&id=ec5324ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5324ac",
  null
  
)

export default component.exports